import { render, staticRenderFns } from "./LogosBlockCms.vue?vue&type=template&id=339cff1d&scoped=true&"
import script from "./LogosBlockCms.vue?vue&type=script&lang=js&"
export * from "./LogosBlockCms.vue?vue&type=script&lang=js&"
import style0 from "./LogosBlockCms.vue?vue&type=style&index=0&id=339cff1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339cff1d",
  null
  
)

export default component.exports